export const GET_USER_DETAILS = "/api/v1/customer/get-user-details?user_id=";
export const VALIDATE_USER = "/api/v1/customer/validate-user";
export const GET_CUSTOMER_CURRENT_PLAN =
  "/api/v1/plans/get-user-plans?crm_service_account_id=";
export const GET_PAYMENT_DETAILS = "/api/v1/payment/view-acct-balance";
export const GET_SERIVICE_TICKETS = "/api/v1/servicecase/get-all-open-case";
export const GET_SERIVICE_ALL_TICKETS = "/api/v1/servicecase/get-all-case";
export const INSERT_SERVICE_TICKET = "/api/v1/servicecase/service-request";
export const SF_FILE_UPLOAD = "/api/v1/communication/sf-file-upload";
export const GET_SERVICE_TYPES =
  "/api/v1/servicecase/service-type?user_type_code=";
export const GET_SERVICE_SUB_TYPES =
  "/api/v1/servicecase/service-subtype?user_type_code=";
export const GET_ALL_MESSAGE_LIST =
  "api/v1/servicecase/get-messages?crm_contact_id=";
export const CREATE_MESSAGE_INSERT = "api/v1/servicecase/create-message";
export const GET_ALL_PROPERTY_LIST = "api/v1/properties/list?user_id=";
export const UPDATE_PROPERTY_ITEM = "api/v1/properties/put?user_id=";
export const GET_ACCOUNTS_DETAILS =
  "api/v1/customer/get-account-details?user_id=";
export const CREATE_CASE_COMMANTS = "api/v1/servicecase/create-case-comment";
export const GET_CASE_COMMENT_LIST =
  "api/v1/servicecase/get-all-comments?crm_contact_id=";
export const GET_PAYMENT_HISTORY_LIST = "api/v1/payment/payment-history";
export const GET_AUTO_PAY_STATUS =
  "api/v1/plans/get-autopay-status?crm_billing_group_id=";
export const ONETIME_PAYMENT = "api/v1/payment/onetime-payment";
export const GET_PAYMENT_PROFILES =
  "api/v1/payment/get-payment-profiles?crm_customer_id=";
export const DELETE_PAYMENT_PROFILES = "api/v1/payment/delete-payment-profile";
export const GET_BILLING_HISTORY_LIST = "api/v1/statements/statement-history";
export const GET_TRANSACTION_HISTORY_LIST =
  "api/v1/payment/transaction-history";
export const GET_BILLING_HISTORY_PDF = "api/v1/statements/get-statement-pdf";
export const GET_USEAGE_HISTORY = "/api/v1/consumption/usage-history";
export const GET_LEGACY_REGISTRATION_COUNT =
  "/api/v1/legacy/get-registration-count";
export const GET_ROLE_SETTINGS =
  "/api/v1/useraccess/user-permissions?user_role_id=";
export const INSERT_ROLE_SETTINGS =
  "/api/v1/useraccess/modify-user-permissions";
export const INSERT_REGISTER_USER =
  "/api/v1/useraccess/modify-user-permissions";
export const REGISTRATION_OTP_PHONE_SEND =
  "/api/v1/communication/phone-otp-sms";
export const REGISTRATION_OTP_EMAIL_SEND =
  "/api/v1/communication/email-otp-sms";
export const FORGOT_PASSWORD_OTP_EMAIL_SEND =
  "/api/v1/communication/send-forget-otp-email";
export const VALIDATE_REGISTRATION_OTP = "/api/v1/communication/validate-otp";
export const GET_PLAN_ADDONS = "/api/v1/plans/get-user-plan-addons";
export const GET_COMMUNICATION_CONTACTS =
  "/api/v1/communication/get-communication-contacts?billing_group_id=";
export const ADD_COMMUNICATION_CONTACTS =
  "/api/v1/communication/add-communication-contacts";
export const EDIT_COMMUNICATION_CONTACTS =
  "/api/v1/communication/update-communication-contacts?contact_id=";
export const GET_COMMUNICATION_PREFERENCES =
  "/api/v1/communication/get-user-communication-preferences?billing_group_id=";
export const UPDATE_COMMUNICATION_PREFERENCES =
  "/api/v1/communication/update-user-communication-preferences";
export const UPDATE_DEFAULT_TOKEN =
  "api/v1/payment/update-auto-pay-default-token?crm_customer_id=";
export const SERVCIE_CANCEL_REQUEST =
  "/api/v1/servicecase/create-cancel-request";
export const GET_ANNOUCEMENT_LIST = "/api/v1/announcement";
export const GET_ACTIVE_ANNOUCEMENT_LIST = "/api/v1/announcement/active";
export const ADD_ANNOUCEMENT = "/api/v1/announcement";
export const GET_ANNOUCEMENT_DETAILS_WITH_ID = "/api/v1/announcement/";
export const UPDATE_ANNOUCEMENT_DETAILS_WITH_ID = "/api/v1/announcement/";
export const UPDATE_PRIORITY = "/api/v1/announcement/update-priority";
export const DELETE_ANNOUCEMENT_DETAILS_WITH_ID = "/api/v1/announcement/";
export const GET_CUSTOMER_CURRENT_PLAN_ADDONS =
  "/api/v1/plans/get-user-adddons?crm_service_account_id=";
export const GET_CANCEL_SERIVICE_TICKETS =
  "/api/v1/servicecase/get-all-cancel-case";
export const POST_BOT_CHAT = "/chat";
export const GET_SF_USER_DETAILS =
  "/api/v1/customer/get-sf-user-details?emailOrPhone=";
export const CREATE_USER_ACCOUNT = "/api/v1/customer/create-user-account";
export const CREATE_ADMIN_USER_ACCOUNT = "/api/v1/customer/create-account";
export const POST_VOICE_PARSE = "/parse";
export const GET_USER_CHANGE_PLAN = "/api/v1/plans/get-change-plans";
//export const GET_USER_COMMUNITY_PLANS = "/api/v1/plans/get-community-plans";
export const GET_USER_COMMUNITY_PLANS =
  "/api/v1/centricplans/get-plans-by-community";
export const GET_USER_VOIP_COMMUNITY_PLANS =
  "/api/v1/centricplans/get-voip-plans-by-community";
export const GET_USER_TV_COMMUNITY_PLANS =
  "/api/v1/centricplans/get-cable-plans-by-community";
export const GET_USER_TV_PLANS = "/api/v1/plans/get-cable-plans-by-community";
export const GET_DOC_TYPE_LIST = "/api/v1/staticwebassets/list-endpoints";
export const GET_DOCS_LIST = "/api/v1/staticwebassets/list-folders/";
export const UPLOAD_DOC = "/api/v1/staticwebassets/upload/";
export const DOWNLOAD_DOC = "/api/v1/staticwebassets/download/";
export const DELETE_DOC = "/api/v1/staticwebassets/delete/";
export const DELETE_SUBSCRIBER = "/api/v1/premise/delete-subscriber?";
export const CREATE_SUBSCRIBER = "/api/v1/premise/subscriber-service";
export const USER_PLAN_CHANGES = "/api/v1/plans/user-plan-change";
export const USER_PLAN_ADD_ONS = "/api/v1/plans/user-addon-change";
export const USER_PLAN_ADDONS_UPDATE = "/api/v1/plans/user-addon-change";
export const RESET_PASSWORD = "/api/v1/customer/password-reset";
export const RESET_FORGOT_PASSWORD =
  "/api/v1/customer/anonymous-password-reset";
export const GET_COMMUNICATION_ADDRESS =
  "/api/v1/communication/get-communication-address?billing_group_id=";
export const UPDATE_COMMUNICATION_ADDRESS =
  "/api/v1/communication/update-communication-address?billing_group_id=";
export const UPDATE_PREMISE_ID = "/api/v1/customer/update-builder-premise";
export const GET_CENTRIC_SEARCH_USER =
  "/api/v1/customer/get-sf-user-details?emailOrPhone=";
export const GET_MYACCOUNT_ADDRESS_SEARCH =
  "/api/v1/customer/myaccount-address-search?address=";
export const GET_DUNING_GAS_REPORT =
  "/api/v1/connection/get-dunning-gas-report";
export const GET_DISC_DUNING_GAS_REPORT =
  "/api/v1/connection/get-disconnected-dunning-gas-report";
export const EMAIL_NOTIFY_DISCONNECTION = "/api/v1/connection/email-notify";
export const GET_DEPOSIT_BY_DAYS = "/api/v1/ssservice/get-deposit-by-days";
export const GET_ENROLLMENT_QUEUE_BY_DATE = "/api/v1/Session/last-logs";
export const GET_REFUND_BY_DAYS = "/api/v1/ssservice/get-refund-by-days";
export const GET_DEPOSIT_TRANSACTION_BY_DEPOSITS =
  "/api/v1/ssservice/get-deposit-transaction-by-deposit/";
export const GET_CENTRIC_CUSTOMER_SEARCH_USER =
  "/api/v1/customer/get-address-user-details";
export const APPLY_CASH_CREDIT = "/api/v1/payment/apply-cash-credit";
export const GET_USER_DETAILS_FILTER = "/api/v1/customer/get-user-details";
export const EMAIL_TO_CUSTOMER = "/api/v1/communication/send-email";
export const GET_CENTRIC_MESSAGE_LIST =
  "/api/v1/servicecase/get-all-user-messages";
export const GET_USER_ROLE_LIST = "/api/v1/useraccess/get-user-role-list";
export const CREATE_USER_ROLE = "/api/v1/useraccess/user-role-creation";
export const GET_USER_SERVICE_LIST = "/api/v1/useraccess/get-user-service-list";
export const GET_USER_LIST = "/api/v1/useraccess/get-user-list?userType=";
export const UPDATE_USER_ACCOUNT_ROLE =
  "/api/v1/useraccess/user-role-account-update";
export const FIBER_CONNECTION_DETAILS =
  "/api/v1/premise/get-premise-ont-status";
export const INTERNAL_USER_LIST = "/api/v1/customer/get-internal-users";
export const GET_SF_BUILDER_DETAILS =
  "/api/v1/customer/get-sf-builder-details?";
export const GENERATE_INVOICE = "/api/v1/invoice/generate";
export const GET_COMMUNITIES_LIST = "/api/v1/signedcommunities";
export const DELETE_COMMUNITY = "/api/v1/signedcommunities/";
export const ADD_COMMUNITY = "/api/v1/signedcommunities";
export const GET_BULK_UPLOAD_LIST = "/api/v1/admin/bulk_upload/listing";
export const GET_BULK_UPLOAD_TEMPLATE = "/api/v1/admin/bulk_upload/template";
export const DOWNLOAD_BULK_UPLOAD_FILE =
  "/api/v1/admin/bulk_upload/download_result?";

export const GET_CENTRIC_SEARCH_USER_BY_PHONE = "/api/v1/customer/get-user-accounts-by-phone?phone=";
